export const CSAT_COLORS = ['#E8344D', '#FA7C21', '#FDCF2E', '#AED91B', '#4CCB56']

export const NPS_COLORS = ['#E8344D', '#E8344D', '#fa7c21', '#fa7c21', '#FDD857', '#FDD857', '#FDCF2E', '#FDCF2E', '#aed91b', '#4CCB56']
